(ns frontend.view.modals.association.sub
  (:require
   [re-frame.core :as rf]))


(rf/reg-sub
 ::selected-tab
 (fn [db _]
   (get db ::selected-tab)))

(rf/reg-sub
 ::import-flow-step
 (fn [db _]
   (get db ::import-flow-step)))

(rf/reg-sub
 ::import-flow-started?
 (fn [db _]
   (get db ::import-flow-started?)))

(rf/reg-sub
 ::uploading?
 (fn [db _]
   (get db ::uploading?)))

(rf/reg-sub
 ::data-import-error
 (fn [db _]
   (get db ::data-import-error)))

(rf/reg-sub
 ::parsing-error?
 (fn [db _]
   (get db ::parsing-error?)))

(rf/reg-sub
 ::creating-associations?
 (fn [db _]
   (get db ::creating-associations?)))

(rf/reg-sub
 ::create-associations-error?
 (fn [db _]
   (get db ::create-associations-error?)))

(rf/reg-sub
 ::import-errors
 (fn [db _]
   (get db ::import-errors)))

(rf/reg-sub
 ::import-data
 (fn [db _]
   (get db ::import-data)))

(rf/reg-sub
 ::import-data-with-errors
 :<-
 [::import-data]
 (fn [import-data-with-possible-matches]
   (->> import-data-with-possible-matches
        (filterv :import-errors))))

(rf/reg-sub
 ::import-flow-ready?
 :<-
 [::import-flow-started?]
 :<-
 [::import-data-with-errors]
 (fn [[import-flow-started? import-data-with-errors]]
   (and import-flow-started?
        (empty? import-data-with-errors))))

(rf/reg-sub
 ::import-data-with-matches
 :<-
 [::import-data]
 (fn [import-data-with-possible-matches]
   (->> import-data-with-possible-matches
        (filterv :entity-match))))

(rf/reg-sub
 ::import-data-without-matches
 :<-
 [::import-data]
 (fn [import-data-with-possible-matches]
   (->> import-data-with-possible-matches
        (remove :entity-match)
        (vec))))
